export default __webpack_public_path__ + "ba41dd10022fd7d93562acf5727a0de9.webp";